<div class="new-ingredient-dialog">
  <mat-label class="dialog-title">
    <span>{{ "createNewIngredient" | translate }} </span>
    <span class="material-symbols-outlined close-button" [mat-dialog-close]
      >close</span
    >
  </mat-label>
  <mat-dialog-content>
    <div class="flex">
      <mat-label class="new-ingredient-header">
        {{ "ingredientName" | translate }}
      </mat-label>
    </div>
    <mat-form-field appearance="outline">
      <input
        matInput
        [placeholder]="newIngredientDialog_ingredientName | translate"
        [value]="ingredientName()"
        (input)="ingredientNameInput($event)"
        required
      />
    </mat-form-field>
    <br />
    <!-- Ingredient Type Selector -->
    <div class="flex">
      <mat-label class="new-ingredient-header">
        {{ "ingredientType" | translate }}
      </mat-label>
    </div>
    <mat-form-field appearance="outline">
      <mat-select
        (selectionChange)="ingredientTypeSelected($event)"
        [(ngModel)]="ingredientType"
        [placeholder]="newIngredientDialog_ingredientType | translate"
      >
        @for (ingrType of ingredientTypes; track ingrType?.name) {
          <mat-option [value]="ingrType?.name">
            {{ ingrType?.name }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions align="start">
    <button
      mat-flat-button
      color="primary"
      (click)="saveIngredient(false)"
      class="primary-button"
      [disabled]="disableButton()"
    >
      {{ "addIngredient" | translate }}
    </button>
    <span
      [matTooltip]="'nutritionDataDisplay' | translate"
      matTooltipPosition="above"
      [matTooltipDisabled]="hasAddPrivileges"
    >
      <button
        mat-flat-button
        color="primary"
        (click)="saveIngredient(true)"
        class="nutritional-data-button"
        [disabled]="disableNutritionButton()"
      >
        {{ "addIngredientAndNutrition" | translate }}
      </button>
    </span>

    <button
      mat-stroked-button
      color="secondary"
      class="secondary-button"
      (click)="resetClick()"
    >
      {{ "reset" | translate }}
    </button>
  </mat-dialog-actions>
</div>
